import "./Header.css";
import React from "react";
import { ServiceList } from "../Components/ServiceList";

export const Header = () => {
    const handleShowServices = () => {
        const service_list = document.getElementById("services_dropdown");
        service_list.classList.toggle("active");
    };

    return (
        <header>
            <div id="contact">
                <a href="tel:343623401" className="info">
                    <i className="fa-solid fa-phone"></i>
                    <span className="additional_info">34 362 34 01</span>
                </a>
                <a href="mailto:stomatolog@agnieszkapolis.pl" className="info">
                    <i className="fa-solid fa-envelope"></i>{" "}
                    <span className="additional_info">
                        stomatolog@agnieszkapolis.pl
                    </span>
                </a>
            </div>
            <h1>
                <i className="fa-solid fa-tooth"></i>Agnieszka Polis
            </h1>
            <div id="services_box">
                <span>
                    <span className="additional_info">Usługi</span>{" "}
                    <i
                        className="fa-solid fa-list"
                        id="list_icon"
                        onClick={handleShowServices}
                    ></i>
                </span>
                <ServiceList />
            </div>
        </header>
    );
};
